/* eslint-disable xss/no-mixed-html */

import React from 'react';
import PropTypes from 'prop-types';
import urls from './urls';
//import supported from '@mapbox/mapbox-gl-supported';
import CodeSnippet from '@mapbox/dr-ui/code-snippet';
//import Note from '@mapbox/dr-ui/note';
import { highlightSwift } from '@mapbox/dr-ui/highlight/swift';
import * as helpers from '@mapbox/dr-ui/edit/helpers';
import ControlToggleSet from '@mapbox/mr-ui/control-toggle-set';

const viewport = `<meta name="viewport" content="initial-scale=1,maximum-scale=1,user-scalable=no" />`;
const css = `\tbody { margin: 0; padding: 0; }
\t#map { position: absolute; top: 0; bottom: 0; width: 100%; background:#ddd;}`;

export default class Example extends React.Component {
    static defaultProps = {
        displaySnippet: true,
        height: 400
    };
    constructor(props) {
        super(props);
        this.state = {
            // unsupported: false,
            selectedFramework: 'mapbox'
        };
    }

    getContent(html) {
        return html;
    }
    displayHTML(html) {
        html = this.getContent(html);
        let env = this.state.selectedFramework;
        this.componentDidMount();
        
        return `${html}`;
    }

    renderHTML(html) {
        let env = this.state.selectedFramework;
        
        return `${html}`;
    }

    renderSnippet() {
        const { html, location } = this.props;
        const code = this.displayHTML(html);

    //  var scriptRegex = /<script>((.|\n)*)<\/script>/;
        //const parsedCode = helpers.extractor(code);
        return (
            <div className="bg-white">
                <div id="code" className="relative">
                    <CodeSnippet
                        code={this.displayHTML(html)}
                        highlighter={() => highlightSwift}
                        edit={{
                            frontMatter: {
                                ...this.props.frontMatter,
                                pathname: location.pathname
                            },
                            head: viewport,
                            js:html,
                            html: html,
                            css: "",
                            resources: ""
                        }}
                    />
                </div>
            </div>
        );
    }
    render() {
        const { frontMatter, height } = this.props;
        var src = "/assets/" + frontMatter.thumbnail + ".png";
        return (
            <div className="prose">
                <img src={src} alt={frontMatter.title}/>
                <ControlToggleSet
                    id="select-quickstart"
                    themeToggleGroup="bg-blue py3 px3 my12"
                    themeToggle="txt-s py3 toggle--white toggle--active-blue"
                    onChange={(value) => {
                        this.setState({ selectedFramework: value });
                    }}
                    value={this.state.selectedFramework}
                    options={[
                        {
                            label: 'Flutter',
                            value: 'mapbox'
                        }
                    ]}
                />
                {this.props.displaySnippet && this.renderSnippet()}
            </div>
        );
    }

    componentDidMount() {
        //if (!supported()) this.setState({ unsupported: true });
        let html = this.getContent(this.props.html);
        //if (!this.iframe) return;
        html = this.renderHTML(html);
        // html = html
        //     .replaceAll('{YOUR_API_KEY}', api_key)
        //     .replaceAll('{YOUR_API_KEY_MAPBOX_GL_JS}', api_key_mapbox)
        //     .replaceAll('{Google_Map_API_KEY}', google_api_key);
        // const doc = this.iframe.contentWindow.document;
        // doc.open();
        // doc.write(html);
        // doc.close();
    }
}

Example.propTypes = {
    html: PropTypes.string, // eslint-disable-line
    frontMatter: PropTypes.shape({
        title: PropTypes.string.isRequired
    }),
    location: PropTypes.shape({
        pathname: PropTypes.string
    }),
    displaySnippet: PropTypes.bool,
    height: PropTypes.number
};
